(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["drv-product-coupon"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('drv-product-coupon')) {
    customElements.define('drv-product-coupon', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const button = this.querySelector('button');
        const status = this.querySelector('[role="status"]');
        button.hidden = false;
        button.addEventListener('click', async () => {
          button.disabled = true;
          let copied = false;
          try {
            if (navigator.clipboard && window.isSecureContext) {
              await navigator.clipboard.writeText(this.dataset.code);
              copied = true;
            }
          } catch (_) {}
          if (!copied) {
            const selection = window.getSelection();
            const range = document.createRange();
            range.selectNodeContents(this.querySelector('.drv-product-coupon__code'));
            selection.removeAllRanges();
            selection.addRange(range);
            try { copied = document.execCommand('copy'); } catch (_) {}
            if (copied) selection.removeAllRanges();
          }
          status.textContent = copied ? this.dataset.success : this.dataset.failure;
          button.disabled = false;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["drv-unified-product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    const initCard = (card) => {
      if (!(card instanceof HTMLElement) || card.dataset.drvUnifiedReady === 'true') return;
      card.querySelectorAll('[data-drv-unified-link]').forEach((link) => {
        link.addEventListener('pointerdown', (event) => event.stopPropagation());
        link.addEventListener('click', (event) => {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          event.stopPropagation();
          window.location.assign(link.href);
        });
      });
      card.querySelectorAll('[data-drv-card-swatch]').forEach((swatch) => {
        swatch.addEventListener('pointerdown', (event) => event.stopPropagation());
        swatch.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          const variantUrl = swatch.dataset.drvVariantUrl;
          const variantImage = swatch.dataset.drvVariantImage;
          const variantPrice = swatch.dataset.drvVariantPrice;
          const variantCompareAtPrice = swatch.dataset.drvVariantCompareAtPrice;
          const amount = Number(swatch.dataset.drvVariantPriceAmount);
          const compareAmount = Number(swatch.dataset.drvVariantCompareAmount);
          const discount = compareAmount > amount && amount > 0 ? Math.round((compareAmount - amount) * 100 / compareAmount) : 0;
          let badge = card.querySelector('.drv-unified-card__save');
          if (!badge && discount > 0) { badge = document.createElement('span'); badge.className = 'drv-unified-card__save'; card.querySelector('.drv-unified-card__title-row')?.append(badge); }
          if (badge) { badge.hidden = discount <= 0; badge.textContent = 'Save ' + discount + '%'; }
          card.querySelectorAll('[data-drv-card-swatch]').forEach((item) => {
            const selected = item === swatch;
            item.classList.toggle('is-selected', selected);
            item.setAttribute('aria-current', selected ? 'true' : 'false');
          });
          if (variantUrl) {
            card.dataset.drvProductUrl = variantUrl;
            card.querySelectorAll('[data-drv-unified-link]').forEach((link) => { link.href = variantUrl; });
          }
          const image = card.querySelector('.drv-unified-card__image--primary');
          if (image && variantImage) { image.src = variantImage; image.srcset = variantImage; }
          const price = card.querySelector('.drv-unified-card__price');
          if (price && variantPrice) {
            const regularPrice = price.querySelector('.price__regular');
            if (regularPrice) regularPrice.textContent = variantPrice.trim();
            let salePrice = price.querySelector('.price__sale');
            if (variantCompareAtPrice?.trim()) {
              if (!salePrice) { salePrice = document.createElement('span'); salePrice.className = 'price__sale'; price.append(salePrice); }
              salePrice.textContent = variantCompareAtPrice.trim();
              price.classList.add('price--on-sale');
            } else {
              salePrice?.remove();
              price.classList.remove('price--on-sale');
            }
          }
        }, true);
      });
      card.addEventListener('pointerdown', (event) => event.stopPropagation());
      card.addEventListener('click', (event) => {
        if (event.defaultPrevented) return;
        const interactive = event.target instanceof Element && event.target.closest('a, button, input, label, select, textarea, [role="button"]');
        if (interactive) return;
        if (card.dataset.drvProductUrl) window.location.assign(card.dataset.drvProductUrl);
      });
      card.dataset.drvUnifiedReady = 'true';
    };
    const initAll = (root = document) => root.querySelectorAll('[data-drv-unified-card]').forEach(initCard);
    initAll();
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches('[data-drv-unified-card]')) initCard(node);
        initAll(node);
      }));
    }).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
